/**
 * Created by heshufen on 22/10/13.
 */
import * as React from "react";
import {getTagCategoryList} from '../../apis'
import {Horizontal, Image, Text, Vertical} from "../../../../components/index";
import {connect} from "react-redux";
import * as ActionTypes from "../../ActionTypes";

const screenHeight = window.screen.height;

class ProductionTypeScreen extends React.Component {
    state = {
        loading: true,
        list: []
    };

    constructor() {
        super(...arguments);

        document.title = '作品分类';
        getTagCategoryList({userId: this.props.match.params._id}).then(res => {
            if (res.isOk) {
                this.setState({list: res.data.data, loading: false})
            }
        })
    }

    toProductList = (tag) => {
        this.props.savePosition(0);
        this.props.history.push('/' + this.props.match.params._id + '/productList/' + tag)
    };

    render() {
        if (this.state.loading)
            return this.renderLoading();
        const {list} = this.state
        return <Vertical style={{backgroundColor: '#fff', height: screenHeight}}>
            {list && list.length > 0 && list.map((type, index) => {
                return (
                    <Vertical>
                        <Text style={{
                            marginTop: index == 0 ? 10 : 40,
                            marginLeft: 15,
                            fontFamily: "PingFangSC-Medium",
                            fontSize: 16,
                            color: "#000000",
                        }}>{type.title}</Text>
                        <Horizontal style={{
                            marginLeft: 5,
                            flexWrap: 'wrap'
                        }}>
                            {type.list.map((item) => {
                                return (
                                    <Horizontal style={{
                                        marginTop: 12,
                                        marginLeft: 10,
                                        paddingLeft: 18,
                                        paddingRight: 18,
                                        height: 30,
                                        borderRadius: 15,
                                        backgroundColor: "#f2f3f4",
                                        alignItems: 'center'
                                    }} onClick={() => this.toProductList(item.tag)}>
                                        <Text style={{
                                            fontFamily: "PingFangSC-Regular",
                                            fontSize: 13,
                                            color: "#0d0d0e"
                                        }}>{item.tag + ' ' + item.num}</Text>
                                    </Horizontal>
                                )
                            })}
                        </Horizontal>
                    </Vertical>
                )
            })}
        </Vertical>
    }

    renderLoading() {
        return <Vertical style={splash.root}>
            <Image source={require('../../assets/loading.gif')} style={splash.loading}/>
        </Vertical>
    }
}

export default connect((state) => {
    return {
        position: state.app.position_product_list,
    }
}, (dispatch) => {
    return {
        savePosition: (position) => dispatch({type: ActionTypes.SAVE_POSITION_PRODUCT_LIST, position}),
    }
})(ProductionTypeScreen);


const splash = {
    root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff'
    },

    loading: {
        height: 50,
        width: 80
    }
};



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/product/ProductionTypeScreen.js